import { EnvContribution, getLegacyBindingContext } from "@visactor/vrender-core";

import { bindNodeCanvasModules } from "../canvas/contributions/node/modules";

import { bindNodeWindowContribution } from "../window/contributions/node-contribution";

import { NodeEnvContribution } from "./contributions/node-contribution";

export function bindNodeEnv(container) {
    var _a, _b;
    (null === (_b = (_a = container).isBound) || void 0 === _b ? void 0 : _b.call(_a, NodeEnvContribution)) || (container.bind(NodeEnvContribution).toSelf().inSingletonScope(), 
    container.bind(EnvContribution).toService(NodeEnvContribution));
}

export function loadNodeEnv(container = getLegacyBindingContext(), loadPicker = !0) {
    loadNodeEnv.__loaded || (loadNodeEnv.__loaded = !0, bindNodeEnv(container), bindNodeCanvasModules(container), 
    bindNodeWindowContribution(container));
}

loadNodeEnv.__loaded = !1;

export function initNodeEnv() {
    loadNodeEnv();
}
//# sourceMappingURL=node.js.map